import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { environment } from 'src/environments/environment';
import { AuthUtilsService } from '../../../utils/auth-utils.service';
import { GoogleAnalyticsService } from 'src/app/utils/google-analytics.service';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-auth-account',
  templateUrl: './auth-account.component.html',
  styleUrls: ['./auth-account.component.scss'],
})
export class AuthAccountComponent implements OnInit, OnDestroy {
  loading: boolean;
  seePassword = false;
  seeRepPassword = false;
  environment = environment;
  warningMessage = `
  ¡ATENCIÓN!: Estás en la página de testing de TiendaCrypto. Para ingresar a la
  página oficial <a href="${environment.prodAppUrl}">clickeá acá</a>.`;
  referCode: string;

  passwordControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=\-_!*()@%&.,?/|:<>~'"]).{8,}$/),
  ]);
  passRepControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=\-_!*()@%&.,?/|:<>~'"]).{8,}$/),
    this.repeatControlValidator(this.passwordControl),
  ]);
  registerForm: FormGroup = this.fb.group({
    emailControl: ['', [Validators.required, Validators.email]],
    passwordControl: this.passwordControl,
    passRepControl: this.passRepControl,
  });
  referRegister = false;
  constructor(
    private fb: FormBuilder,
    public router: Router,
    public authentication: AuthenticationService,
    public utils: AuthUtilsService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private titleService: Title,
    private metaService: Meta,
  ) {
    this.titleService.setTitle('¡Registrate en TiendaCrypto!');
    this.metaService.addTag({
      name: 'Registrate en TiendaCrypto',
      content: 'Cambia tus criptomonedas favoritas de manera rápida y segura en TiendaCrypto',
    });
  }

  ngOnInit() {
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.titleService.setTitle('TiendaCrypto');
  }

  register() {
    this.seePassword = false;
    this.seeRepPassword = false;

    if (this.registerForm.invalid) {
      this.utils.touchControls(this.registerForm);
      return;
    }

    if (this.loading) {
      return;
    }

    this.loading = true;

    const { emailControl, passwordControl } = this.registerForm.value;

    this.authentication
      .register((emailControl as string).trim(), (passwordControl as string).trim(), this.referCode)
      .subscribe(
        (res) => {
          this.googleAnalyticsService.emitEvent('email-signup', 'first-use', 'click');
          this.loading = false;
        },
        (err) => {
          if (err.error.internalStatus === 'USER_EXISTS') {
            this.registerForm.controls.emailControl.setErrors({ emailAlreadyTaken: true });
          }
          this.loading = false;
        },
      );
  }

  repeatControlValidator(repeatable: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null =>
      control.value !== repeatable.value ? { notRepeated: true } : null;
  }
}
